import { defineMessages } from 'react-intl';

export const programMessages = defineMessages({
    'program.title': {
        id: 'program.title',
        defaultMessage: 'Loading Program...',
        description: 'Text to display when the program is loading.',
    },
    'program.program_actions': {
        id: 'program.program_actions',
        defaultMessage: 'Show program actions',
        description: 'Button to show program actions.',
    },
    'program.before_viewing_join': {
        id: 'program.before_viewing_join',
        defaultMessage:
            'Before viewing this session we recommend you join the program.',
        description: 'Prompt to join the program before viewing a session.',
    },
    'program.before_favoriting_join': {
        id: 'program.before_favoriting_join',
        defaultMessage:
            'Before favoriting this session we recommend you join the program.',
        description: 'Prompt to join the program before favoriting a session.',
    },
    'program.enter_access_code': {
        id: 'program.enter_access_code',
        defaultMessage: 'Enter Access Code',
        description: 'Button text for the user to enter an access code.',
    },
    'program.enter_your_access_code': {
        id: 'program.enter_your_access_code',
        defaultMessage: 'Enter Your Access Code',
        description: 'Button text for the user to enter their access code.',
    },
    'program.validate_your_eligibility': {
        id: 'program.validate_your_eligibility',
        defaultMessage:
            'Validate your eligibility to unlock the full Calm Health experience.',
        description: 'Prompt to validate the user’s eligibility.',
    },
    'program.content_locked': {
        id: 'program.content_locked',
        defaultMessage: 'Content Locked',
        description:
            'Text to display when the content is locked because the user does not have a subscription.',
    },
    'program.in_order_to_unlock': {
        id: 'program.in_order_to_unlock',
        defaultMessage:
            'In order to unlock this content, we need to validate your eligibility for Calm Health.',
        description:
            'Explanation of that the user needs to validate their eligibility to unlock the content.',
    },
    'program.validate_eligibility': {
        id: 'program.validate_eligibility',
        defaultMessage: 'Validate Eligibility',
        description: 'Button to validate the user’s eligibility.',
    },
    'program.join_program': {
        id: 'program.join_program',
        defaultMessage: 'Join Program',
        description: 'Button to join the program.',
    },
    'program.simple_join': {
        id: 'program.simple_join',
        defaultMessage: 'Join',
        description: 'Short button text to join a program.',
    },
    'program.related': {
        id: 'program.related',
        defaultMessage: 'Related',
        description: 'Related content (to the current program) section title',
    },
    'program.dismiss_program': {
        id: 'program.dismiss_program',
        defaultMessage: 'Dismiss Program',
        description: 'Button to dismiss the program.',
    },
    'program.restart_program': {
        id: 'program.restart_program',
        defaultMessage: 'Restart Program',
        description: 'Button to restart the program.',
    },
    'program.simple_restart': {
        id: 'program.simple_restart',
        defaultMessage: 'Restart',
        description: 'Short button text to restart a program.',
    },
    'program.leave_program': {
        id: 'program.leave_program',
        defaultMessage: 'Leave Program',
        description: 'Button to leave the program.',
    },
    'program.program_completed_title': {
        id: 'program.program_completed_title',
        defaultMessage: "You've completed this program.",
        description: 'Explanation that the user has completed the program.',
    },
    'program.program_completed_body': {
        id: 'program.program_completed_body',
        defaultMessage: 'This program was completed on {date}.',
        description: 'Text explaining when the user completed the program.',
    },
    'program.program_completed_rated': {
        id: 'program.program_completed_rated',
        defaultMessage: 'You rated this program',
        description: 'Text describing that the user has provided rating.',
    },
    'program.program_completed.rating_label': {
        id: 'program.program_completed.rating_label',
        defaultMessage: '{count} star rating',
        description: 'Text describing the user’s rating of the program.',
    },
    'program.how_to_get_started': {
        id: 'program.how_to_get_started',
        defaultMessage: 'How to Get Started',
        description:
            'Title for the section that explains how to get started with a program.',
    },
    'program.how_to_get_started_with': {
        id: 'program.how_to_get_started_with',
        defaultMessage: 'How to Get Started with {title}',
        description: 'Section for how to get started with a specific program.',
    },
    'program.what_youll_get': {
        id: 'program.what_youll_get',
        defaultMessage: "What You'll Get",
        description: 'Title for the benefits of a program.',
    },
    'program.poll_caption': {
        id: 'program.poll_caption',
        defaultMessage: '1 - 2 min',
        description: 'Estimated time to complete the mental health screening.',
    },
    'program.poll_subtitle': {
        id: 'program.poll_subtitle',
        defaultMessage:
            'Take the mental health screening to complete the program',
        description:
            'Prompt to take the mental health screening to complete the program.',
    },
    'program.next_session': {
        id: 'program.next_session',
        defaultMessage: 'Next Session',
        description: 'Button for playing the next session in the program.',
    },
    'program.next_session_will_start': {
        id: 'program.next_session_will_start',
        defaultMessage: 'Next Session will start in {autoStartSeconds} seconds',
        description:
            'Explanation that the next session will start automatically in a few seconds.',
    },
    'program.next_session_will_start_one_second': {
        id: 'program.next_session_will_start_one_second',
        defaultMessage: 'Next Session will start in 1 second',
        description:
            'Explanation that the next session will start automatically in one second.',
    },
    'program.poll_title': {
        id: 'program.poll_title',
        defaultMessage: 'Mental Health Screening',
        description: 'Title for the mental health screening.',
    },
    'program.leave_program_error': {
        id: 'program.leave_program_error',
        defaultMessage: 'Error: Unable to leave program',
        description:
            'Error message when the user is unable to leave the program.',
    },
    'program.join_program_error': {
        id: 'program.join_program_error',
        defaultMessage: 'Error: Unable to join program',
        description:
            'Error message when the user is unable to join the program.',
    },
    'program.already_joined': {
        id: 'program.already_joined',
        defaultMessage: 'You have already joined another program',
        description:
            'Explanation that the user has already joined another program.',
    },
    'program.allowed_to_join_multiple': {
        id: 'program.allowed_to_join_multiple',
        defaultMessage:
            'While we allow you to join multiple programs, we encourage you to focus on one program at a time to maximize your focus.',
        description: 'Explanation show when a user joins multiple programs.',
    },
    'program.acknowlege_join': {
        id: 'program.acknowlege_join',
        defaultMessage: 'Acknowledge and Join Program',
        description: 'Button to acknowledge and join the program.',
    },
    'program.limit_sessions': {
        id: 'program.limit_sessions',
        defaultMessage: 'Limit your sessions',
        description: 'Title for limiting the number of sessions.',
    },
    'program.limit_sessions_description': {
        id: 'program.limit_sessions_description',
        defaultMessage:
            'Limit your sessions to two per day. In the meantime, we encourage you to access the Calm library and explore our collections of sleep stories, meditations, music and mindfulness.',
        description:
            'Explanation of why the user is being asked to limit their sessions.',
    },
    'program.explore_calm': {
        id: 'program.explore_calm',
        defaultMessage: 'Explore Calm',
        description: '',
    },
    'program.discover_calm': {
        id: 'program.discover_calm',
        defaultMessage: 'Discover Calm',
        description:
            'Header for the section that lists all of the Calm content available.',
    },
    'program.watch_later': {
        id: 'program.watch_later',
        defaultMessage: "Ok, I'll Watch Later",
        description: 'Button to watch the session later.',
    },
    'program.worksheets_and_tools': {
        id: 'program.worksheets_and_tools',
        defaultMessage: 'Worksheets and Tools',
        description:
            'Title for the section that lists content for the user to reference.',
    },
    'program.session_worksheet': {
        id: 'program.session_worksheet',
        defaultMessage:
            'Here are worksheets and tools that will be helpful during the "{title}" session.',
        description: 'Header for the worksheets and tools for a session.',
    },
    'program.session_worksheet_cta': {
        id: 'program.session_worksheet_cta',
        defaultMessage: 'Worksheets and Tools',
        description:
            'Player button cta for displaying worksheets and tools dialog',
    },
    'program.journaling.session_worksheet_cta': {
        id: 'program.journaling.session_worksheet_cta',
        defaultMessage: 'AI Journal and Worksheets',
        description:
            'Player button cta for displaying AI journal and worksheets dialog',
    },
    'program.nice_youve_completed_session': {
        id: 'program.nice_youve_completed_session',
        defaultMessage: "Nice work! You've completed session {number}",
        description: 'Displayed when the user has completed a session.',
    },
    'program.youve_completed_session': {
        id: 'program.youve_completed_session',
        defaultMessage: "You've completed session {number}",
        description: 'Displayed when the user has completed a session.',
    },
    'program.youve_completed_first_x_sessions': {
        id: 'program.youve_completed_first_x_sessions',
        defaultMessage: "You've completed the first {x} sessions for",
        description: 'Displayed when the user has completed a session.',
    },
    'program.youre_making_progress': {
        id: 'program.youre_making_progress',
        defaultMessage: "You're making progress with {program}.",
        description: 'Displayed when the user has completed a session.',
    },
    'program.youre_x_percent_there': {
        id: 'program.youre_x_percent_there',
        defaultMessage: "You're {percent}% there!",
        description: 'Displayed when the user has completed a session.',
    },
    'program.this_program': {
        id: 'program.this_program',
        defaultMessage: 'this program',
        description: 'this program',
    },
    'program.your_answer_submitted': {
        id: 'program.your_answer_submitted',
        defaultMessage: 'Thanks, your answer has been submitted.',
        description: 'Confirmation that the user’s answer has been submitted.',
    },
    'program.did_you_find_session_helpful': {
        id: 'program.did_you_find_session_helpful',
        defaultMessage: 'Did you find this session helpful?',
        description: 'Displayed when the user has completed a session.',
    },
    'program.cadence_title': {
        id: 'program.cadence_title',
        defaultMessage: 'Session Cadence',
        description: 'Title of the section that explains the session cadence.',
    },
    'program.cadence_body': {
        id: 'program.cadence_body',
        defaultMessage:
            'We suggest you listen to these at your own pace, but don’t recommend viewing more than {maxPerDay} in a day.',
        description: 'Suggestion of how many sessions to view in a day.',
    },
    'program.favoriting_title': {
        id: 'program.favoriting_title',
        defaultMessage: 'Session Favoriting',
        description:
            'Title of the section for marking a section as a favorite.',
    },
    'program.favoriting_body': {
        id: 'program.favoriting_body',
        defaultMessage:
            'Favorite the sessions that have made an impact for easy access from your library.',
        description: 'Explanation of why the user should favorite a session.',
    },
    'program.completion_title': {
        id: 'program.completion_title',
        defaultMessage: 'Program Completion',
        description:
            'Title for the section explaining how to complete a program.',
    },
    'program.completion_body': {
        id: 'program.completion_body',
        defaultMessage:
            'To complete the program we will ask you to track your progress by updating your mental health screening.',
        description:
            'Explanation of the mental health screening related to completing a program.',
    },
    'program.tracking_title': {
        id: 'program.tracking_title',
        defaultMessage: 'Tracking Progress',
        description: 'Title for the tracking progress section.',
    },
    'program.tracking_body': {
        id: 'program.tracking_body',
        defaultMessage:
            'Track your progress overtime, changes don’t always happen over night.',
        description: 'Explanation of why the user should track their progress.',
    },
    'program.program_joined': {
        id: 'program.program_joined',
        defaultMessage: 'Program Joined',
        description: 'Text to display when the user has joined a program.',
    },
    left_program: {
        id: 'program.left_program',
        defaultMessage: 'Left Program',
        description: 'Text to display when the user has left a program.',
    },
    'program.cant_take_poll': {
        id: 'program.cant_take_poll',
        defaultMessage: 'Completing the Program',
        description:
            'Explanation of why the user cannot take the mental health screening.',
    },
    'program.cant_take_poll_body': {
        id: 'program.cant_take_poll_body',
        defaultMessage:
            'You must watch all the content in the program before unlocking this mental health screening to complete the program.',
        description:
            'Explanation of why the user cannot take the mental health screening.',
    },
    'program.youve_completed': {
        id: 'program.youve_completed',
        defaultMessage: "You've completed",
        description: 'Displayed when the user has completed a program.',
    },
    'program.update_care_plan_after_rating': {
        id: 'program.update_care_plan_after_rating',
        defaultMessage:
            "We'll update your Plan after you submit your program rating. On a scale from 1-5, how effective was this program for you?",
        description:
            'Prompt for feedback after the user has completed a program.',
    },
    'program.program_completed.add_rating': {
        id: 'program.program_completed.add_rating',
        defaultMessage:
            "We'll save your program rating. On a scale from 1-5, how effective was this program for you?",
        description:
            'Prompt for feedback after the user has completed a program.',
    },
    'program.rate_program': {
        id: 'program.rate_program',
        defaultMessage: 'Rate Program',
        description:
            'Title for the section that asks the user to rate the program.',
    },
    'program.rating_successful': {
        id: 'program.rating_successful',
        defaultMessage: 'Rating successfully submitted',
        description:
            'Displayed when the user has successfully submitted a rating.',
    },
    'program.rating_submitted': {
        id: 'program.rating_submitted',
        defaultMessage: 'Rating submitted',
        description:
            'Toast confirmation shown after the user submits their program rating.',
    },
    'program.please_select_rating': {
        id: 'program.please_select_rating',
        defaultMessage:
            'Please select a star rating for the program to proceed',
        description: 'Prompt to select a star rating for the program.',
    },
    'program.summary_title': {
        id: 'program.summary_title',
        defaultMessage: 'Summary',
        description: 'Title for the section that summarizes the program.',
    },
    'program.favorite_sessions_title': {
        id: 'program.favorite_sessions_title',
        defaultMessage: 'Favorite Sessions',
        description:
            'Title for the section that lists the user’s favorite sessions.',
    },
    'program.favorite_sessions_body': {
        id: 'program.favorite_sessions_body',
        defaultMessage:
            'Favorite the sessions that resonated with you. Access your Favorites easily from the Home screen at anytime.',
        description: 'Explanation of why the user should favorite a session.',
    },
    'program.check_ins_title': {
        id: 'program.check_ins_title',
        defaultMessage: 'Mental Health Check Ins',
        description: 'Section title for mental health check ins.',
    },
    'program.check_ins_body': {
        id: 'program.check_ins_body',
        defaultMessage:
            'We’ll ask you to check in and take a mental health screening every 4 weeks to continuously review your journey.',
        description: 'Explanation of the mental health check ins.',
    },
    'program.error.misconfigured.title': {
        id: 'program.error.misconfigured.title',
        defaultMessage: 'Program Unavailable',
        description: 'Title shown when a clinical program is misconfigured.',
    },
    'program.error.misconfigured.body': {
        id: 'program.error.misconfigured.body',
        defaultMessage:
            'This program is temporarily unavailable. Please try another program or contact support.',
        description:
            'Body text shown when a clinical program is misconfigured.',
    },
});

export default programMessages;
